import { ResponseFormat } from './index.js'

export interface IAppConfig {
  /** An optional string to use as the base URL for all requests. */
  baseUrl?: string

  /** Your API key for authenticating requests. */
  apiKey: string

  /**
   * The format to use for all responses from the API, defaults to `json`. You
   * can also override this value for individual requests.
   */
  responseFormat?: ResponseFormat

  /**
   * Determines what kind of data should be returned from the API when using the
   * `sendRequest` method of the `BaseRoute` class. For example, if the value
   * is set to `true` (the default value) then only the `data`, `status`, and
   * `statusText` properties of the response will be returned. If the value is
   * set to `false` then the entire response object is returned.
   */
  trimmedResponses?: boolean

  /**
   * An optional string to specify where to store response files when using
   * `IOUtil` class. The default value is `./data`, ensuring files are stored
   * in a folder called `data` in the root of the project.
   */
  dataDir?: string

  /**
   * An optional property that, when enabled, displays extra information in the
   * console.
   *
   * The default value is `false`.
   */
  debug?: boolean
}
